export default __webpack_public_path__ + "static/media/wheelchair-tennis-orange.212c84c8.png";